
//TO-DO: Passar estes métodos para a model-sagres
export class FiltrosImpedidos {
    nome: string
    tipoDeImpedimento: string
    cpfCnpj: string
    suspenso: string
    filtroUg: string | null

    constructor() {
        this.limpar();
    }

    limpar(): void {
        this.nome = ''
        this.tipoDeImpedimento = ''
        this.cpfCnpj = ''
        this.suspenso = ''
        this.filtroUg = null
    }

    toFormData(): FormData {
        const data = new FormData()
        if (this.nome)
            data.append("nome", this.nome)
        if (this.tipoDeImpedimento)
            data.append("tipoDeImpedimento", this.tipoDeImpedimento)
        if (this.cpfCnpj)
            data.append("cpfCnpj", this.cpfCnpj)
        if (this.suspenso)
            data.append("suspenso", this.suspenso)
        if (this.filtroUg)
            data.append("filtroUg", this.filtroUg)
        return data
    }

    toQueryString(): string {
        let retorno = ''
        if (this.nome)
            retorno += '&nome=' + this.nome
        if (this.tipoDeImpedimento)
            retorno += '&tipoImpedimento=' + this.tipoDeImpedimento
        if (this.cpfCnpj)
            retorno += '&cpf=' + this.cpfCnpj
        if (this.suspenso)
            retorno += '&suspenso=' + this.suspenso
        if (this.filtroUg)
            retorno += '&filtroUg=' + this.filtroUg
        return retorno
    }
}